/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreDTOsMetricAvailabilitySchema } from "./metricAvailabilitySchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreDTOsReplayGlScoreComponentDtoSchema = z.object({
  key: z.string().nullish(),
  group: z.string().nullish(),
  weight: z.optional(z.number()),
  percentile: z.optional(z.number()),
  contribution: z.optional(z.number()),
  lowerIsBetter: z.optional(z.boolean()),
  get availability() {
    return goodLuckCoreDTOsMetricAvailabilitySchema.optional();
  },
});
